import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7299cf8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-receiver-pairing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-enter-pairing-code-heading" }, "Enter Your Pairing Code", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-enter-pairing-code-text" }, "Enter the pairing code that is displayed on your receiver.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Open the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Ditto Receiver app"),
  /*#__PURE__*/_createTextVNode(" on your receiving device to get the pairing code.")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click Pair Receiver to finish.", -1))
const _hoisted_6 = {
  key: 0,
  class: "onboarding__target onboarding__target--top-left"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-setup-manually-text" }, "Set up your receiver manually instead.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "hide-required-asterisk": "",
      class: "row justify-content-sm-center text-center",
      rules: _ctx.rules,
      model: _ctx.pairingCodeForm,
      ref: "pairingCodeForm",
      "label-position": "top",
      onSubmit: _withModifiers(_ctx.onPair, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          class: "receiver-wizard__width-container mb-0 text-center",
          prop: "pairingCode",
          label: "Enter Your Pairing Code",
          "data-test": "receiver-enter-pairing-code-form"
        }, {
          label: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_el_popover, {
              trigger: "manual",
              placement: "left",
              width: 300,
              "popper-class": "onboarding__popover",
              disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
              visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && !_ctx.pairingCodeForm.pairingCode
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.pairingCodeForm.pairingCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pairingCodeForm.pairingCode) = $event)),
                  placeholder: "Pairing Code",
                  class: _normalizeClass(["pairing-code-input", { 'el-input--onboarding' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && !_ctx.pairingCodeForm.pairingCode}]),
                  "data-test": "receiver-pairing-code-input"
                }, null, 8, ["modelValue", "class"])
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["disabled", "visible"])
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_el_popover, {
            trigger: "manual",
            placement: "left",
            "popper-class": "onboarding__popover width-auto",
            disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded || !_ctx.pairingCodeForm.pairingCode,
            visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "me-2 mt-4",
                onClick: _ctx.onPair,
                type: "primary",
                "data-test": "pair-receiver-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Pair Receiver "),
                  (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && _ctx.pairingCodeForm.pairingCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled", "visible"]),
          _createVNode(_component_el_popover, {
            trigger: "manual",
            placement: "right",
            "popper-class": "onboarding__popover width-auto",
            disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
            visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner && !_ctx.pairingCodeForm.pairingCode
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "ms-0 mt-sm-4 mt-2 mt-sm-0",
                onClick: _ctx.onNextStep,
                "data-test": "receiver-dont-have-code-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("I don't have a code")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled", "visible"])
        ])
      ]),
      _: 1
    }, 8, ["rules", "model", "onSubmit"])
  ]))
}